export const checkIsCurrentDomain = (endpoint: string | undefined): boolean => {
  if (!endpoint) {
    return true;
  }

  return (
    endpoint.startsWith('/') || endpoint.startsWith(window.location.origin)
  );
};
